/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'persistence-profile';

export const persistenceProfileBreadcrumbTitle = `${prefix}.persistenceProfileBreadcrumbTitle`;

export const ENGLISH = {
    [persistenceProfileBreadcrumbTitle]: 'Persistence Profile',
};
